import WebsiteBehaviors from "../website-behaviors/index.js";
import Citation from "../citation.js";

class EbscoResearch extends WebsiteBehaviors {
	identifier() {
		return "EbscoResearch";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		/**
		 * Url examples:
		 * https://research.ebsco.com/c/c4ett2/viewer/html/tw6wbxjew5
		 * https://research.ebsco.com/c/4avftl/viewer/pdf/o4j6mamezb
		 **/
		return getLocationTest("research");
	}

	async generateStructuredCitation() {
		return await generateEdsCitation("research");
	}
}

export default EbscoResearch;

/**
 * The next three functions are also used in the EbscoDiscovery case.
 **/
export const getLocationTest = (urlId: string) => {
	const hostTest = urlId === "research" ? /^research\.ebsco\.com$/ : /^discovery\.ebsco\.com$/;
	return hostTest.test(location.host) && /\/c\/(\w)*\/((viewer\/(html|pdf))|details)\/(\w)*/.test(location.pathname);
};

// Get profileIdentifier and recordId from url pathname
export const getIdsFromPath = () => {
	const pathname = window.location.pathname;

	// ex. /c/c4ett2/viewer/pdf/o4j6mamezb
	// ex. /c/c4ett2/details/c6murbvzxv
	const strings = pathname.split("/");
	const profileIdentifier = strings[2];
	const recordId = strings[5] ? strings[5] : strings[4];

	return {profileIdentifier, recordId};
};

export const generateEdsCitation = async (urlId: string) => {
	const {profileIdentifier, recordId} = getIdsFromPath();

	// Ex. https://research.ebsco.com/linkprocessor/v2-ris?recordId=tw6wbxjew5&opid=c4ett2&lang=en
	const result = await fetch(`https://${urlId}.ebsco.com/linkprocessor/v2-ris?recordId=${recordId}&opid=${profileIdentifier}&lang=en`);
	const ris = await result.text();

	return Citation.fromRIS(ris);
};
